import {
    getTerminateNumberDetailsRoute,
    postTerminateNumberCancellationRoute,
    postTerminateNumberRoute,
} from "@api-routes";
import { useFetch } from "@common/hook/useFetch";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { useContext, useEffect, useState } from "react";
import { ITerminateNumberDetails } from "../interface/ITerminateNumber";

export const useTerminateNumber = () => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [terminateNumberDetails, setTerminateNumberDetails] = useState<ITerminateNumberDetails>();
    const [getTerminateNumberDetailsStatus, { get: getTerminateNumber }] = useFetch();
    const [postTerminationNumberStatus, { post: postTerminationNumber }] = useFetch();
    const [postTerminationNumberCancellationStatus, { post: postpostTerminationNumberCancellation }] = useFetch();

    const getTerminateNumberDetails = () => {
        if (selectedService) {
            getTerminateNumber<ITerminateNumberDetails>(
                getTerminateNumberDetailsRoute(selectedService.subscriptionId)
            ).then((response) => {
                if (response) {
                    setTerminateNumberDetails(response);
                }
            });
        }
    };

    const postNumberTermination = () => {
        if (selectedService) {
            postTerminationNumber<boolean>(postTerminateNumberRoute(selectedService.subscriptionId)).then(
                (response) => {
                    if (response) {
                        getTerminateNumberDetails();
                    }
                }
            );
        }
    };

    const postNumberTerminationCancellation = () => {
        if (selectedService) {
            postpostTerminationNumberCancellation<boolean>(
                postTerminateNumberCancellationRoute(selectedService.subscriptionId)
            ).then((response) => {
                if (response) {
                    getTerminateNumberDetails();
                }
            });
        }
    };

    useEffect(() => {
        getTerminateNumberDetails();
    }, [selectedService]);

    return {
        terminateNumberDetails,
        getTerminateNumberDetailsStatus,
        postTerminationNumberStatus,
        postNumberTermination,
        postTerminationNumberCancellationStatus,
        postNumberTerminationCancellation,
    };
};
